import React, { useEffect, useState } from "react";
import MantineButton from "../../components/mantine/button";
import MantineFlex from "../../components/mantine/flex";
import MantineTextInput from "../../components/mantine/textinput";
import { useForm } from "@mantine/form";
import { onAddnewClient, onupdateClient } from "../../store/actions";
import { PlaceholderUi, validateClientName, validateuploadlogo } from "../../helpers/common";
import { BASEURL } from "../../helpers/url_helper";
import MantineFileInput from "../../components/mantine/uploadfile";

const UserForm = (props: any) => {
  const { handleResponseUserForm, clientData, modalclose, dispatch, currentPrimaryColor } = props;
  const [logoFileUrl, setLogoFileUrl] = useState<string | null>(null);
  const initialValues = {
    name: '',
    logoFileUpload: null,
  };

  const validationRules: any = {
    name: validateClientName,
    logoFileUpload: validateuploadlogo,
  };

  const form = useForm({
    initialValues,
    validate: validationRules,
  });

  const userFormData = () => {
    if (clientData?.id === undefined) {
      form.validate();
    }
    if (form.isValid()) {
      const data = {
        ...form.values,
        id: clientData?.id,
      };
      if (data?.id == undefined) {
        const filteredData = Object.fromEntries(
          Object.entries(data).filter(([_, value]) => value !== undefined)
        );
        dispatch(onAddnewClient(filteredData, handleResponseUserForm));
      } else {
        dispatch(onupdateClient(data, handleResponseUserForm));
      }
    }
  };
  const handleRemoveFile = () => {
    setLogoFileUrl(null);
    form.setFieldValue('logoFileUpload', null);
  };
  useEffect(() => {
    if (clientData) {
      form.setValues({
        name: clientData?.name,
        logoFileUpload: clientData?.logo
      });
      setLogoFileUrl(clientData?.logo || null);
    }
  }, [clientData]);

  const changeImageUrl = (url: any) => {
    return url?.replace(`${BASEURL}/Client/GetImage?fileName=`, '');
  }
  const handleCancel = (event: React.MouseEvent) => {
    event.preventDefault(); 
    modalclose(); 
  };
  return (
    <form onSubmit={form.onSubmit(userFormData)}>
      <MantineFlex className='flex-wrap md:flex-nowrap md:gap-4'>
        <div className="w-full my-2">
          <MantineTextInput
            {...form.getInputProps('name')}
            label={<span>Client Name <span style={{ color: 'red' }}>*</span></span>}
            placeholder="Enter Your First Name"
            classNames={{ input: 'w-[363px] h-[40px] mb-1 bg-white border border-gray-400 rounded-full opacity-100 pr-10',error: 'mt-1 text-sm text-red-600', }}
            error={form.errors.name}
          />
        </div>
        <div className="w-full my-2">
          <MantineFileInput  
            {...form.getInputProps('logoFileUpload')}
            label="Logo"
            withAsterisk
            placeholder="Upload Your Logo"
            classNames={{ input: 'w-[363px] h-[40px] mb-1 bg-white border border-gray-400 rounded-full opacity-100 pr-10' , error: 'mt-1 text-sm text-red-600',}}
            error={form.errors.logoFileUpload}
            fileUrl={changeImageUrl(logoFileUrl)}
            onRemoveFile={handleRemoveFile}
          />       
        </div>
      </MantineFlex>
      <MantineFlex justify='flex-end' className='gap-4'>
        <MantineButton
          name={'Save'}
          className={"mt-[15px] text-sm font-thin !w-[90px]"}
          //onClick={() => userFormData()} 
          color={currentPrimaryColor}
        />
        <MantineButton
          name={'Cancel'}
          className={"bg-secondary_color hover:bg-hover_secondary_btn mt-[15px] text-sm font-thin !w-[100px]"}
          onClick={handleCancel}
        />
      </MantineFlex>
    </form>
  );
};

export default UserForm;
